import { Card, Col, Container, ListGroup, ListGroupItem, Modal, Placeholder, Row } from "react-bootstrap";

import { useEffect, useState } from "react";
import { getLocalDateTimeStr } from "../../../utils/time";
import { callQuery, USER_EVENTS_SESSION_DETAILS } from "../../../amplify/api-gateway/query";


export const RECENT_SESSIONS_COLUMNS = [
    {
        name: "Event Type",
        size: 3,
        id: "event_type"
    },
    {
        name: "Timestamp",
        id: "timestamp",
        size: 3,
    },
    {
        name: "URL",
        id: "url",
        size: 3,
    },
    {
        name: "Username",
        id: "username",
        size: 3,
    },
];

export const AdminUserEventsReportDetailsModal = (props: {
    showModal: boolean,
    setShowModal: any,
    sessionId?: string,
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [recentSessions, setRecentSessions] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>(RECENT_SESSIONS_COLUMNS);

    useEffect(() => {
        if (props.showModal && props.sessionId) {
            setIsLoading(true);

            callQuery({
                operation: USER_EVENTS_SESSION_DETAILS,
                session_id: props.sessionId,
            }).then((promiseOutput: any) => {
                const results = promiseOutput;
                setRecentSessions(results);
            }).finally(() => {
                setIsLoading(false);
        });
        }
    }, [props.showModal, props.sessionId]);

    const formatRowVal = (col: any, row: any) => {
        if (col.id.endsWith("timestamp")) {
            return getLocalDateTimeStr(row[col.id]);
        } else {
            return row[col.id];
        }
    }

    return (
        <Modal show={props.showModal} dialogClassName="modal-90w" onHide={() => props.setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Session Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row className="mb-2">
                        <Col>
                            <Card className="trackboard-table">
                                {isLoading ? (
                                    <Row className="m-4">
                                        <Col>
                                            {[1, 2, 3].map((v) => (
                                                <Row>
                                                    <Col>
                                                        <Placeholder
                                                            key={v}
                                                            xs={6}
                                                        />
                                                    </Col>
                                                </Row>
                                            ))}
                                        </Col>
                                    </Row>
                                ) : (
                                    <>
                                        <ListGroup variant="flush">
                                            <ListGroupItem className="d-flex flex-column trackboard-table-header">
                                                <div
                                                    style={{
                                                        display: "block",
                                                        width: "100%",
                                                    }}
                                                >
                                                    {columns.map((col) => {
                                                        const totalRelativeCols =
                                                            columns.reduce(
                                                                (acc, obj) =>
                                                                    acc + (obj.size ?? 0),
                                                                0
                                                            );
                                                        return (
                                                            <div
                                                                key={col.id}
                                                                style={{
                                                                    display:
                                                                        "inline-block",
                                                                    cursor: "pointer",
                                                                    width: `${
                                                                        (100 *
                                                                            col.size) /
                                                                        totalRelativeCols
                                                                    }%`,
                                                                }}
                                                                onClick={() => {
                                                                    // sortPatients(col.id)
                                                                }}
                                                            >
                                                                {col.name}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </ListGroupItem>
                                            {
                                                recentSessions && recentSessions.map(row => (
                                                    <ListGroupItem className="d-flex flex-column" onClick={() => {
                                                        
                                                    }}>
                                                        <div
                                                            style={{
                                                                display: "block",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            {columns.map((col) => {
                                                                const totalRelativeCols =
                                                                    columns.reduce(
                                                                        (acc, obj) =>
                                                                            acc + (obj.size ?? 0),
                                                                        0
                                                                    );
                                                                return (
                                                                    <div
                                                                        key={col.id}
                                                                        style={{
                                                                            display: "inline-block",
                                                                            cursor: "pointer",
                                                                            width: `${
                                                                                (100 * col.size) / totalRelativeCols
                                                                            }%`,
                                                                        }}
                                                                    >
                                                                        {
                                                                            formatRowVal(col, row)
                                                                        }
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </ListGroupItem>
                                                ))
                                            }
                                        </ListGroup>
                                    </>
                                )}
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    );
};
